// Ícone WhatsApp simplificado (SVG inline) — respeita a prop `size` e `className`
export default function WhatsAppIcon({ size = 16, className = "", strokeWidth: _strokeWidth = 0 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      aria-hidden="true"
      className={className}
      fill="currentColor"
    >
      <path d="M19.11 17.35c-.29-.15-1.7-.84-1.97-.93-.26-.1-.46-.15-.66.15-.19.29-.75.93-.92 1.12-.17.2-.34.22-.63.07-.29-.15-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.61-2-.17-.29-.02-.44.13-.59.13-.13.29-.34.44-.51.15-.17.19-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.49-.66-.5l-.56-.01c-.19 0-.51.07-.78.37-.27.29-1.02.99-1.02 2.42s1.05 2.81 1.2 3c.15.19 2.07 3.16 5.03 4.43.7.3 1.25.49 1.68.63.7.22 1.34.19 1.85.11.56-.08 1.7-.69 1.94-1.36.24-.67.24-1.25.17-1.37-.07-.12-.26-.19-.55-.34zM16.02 5.33c-5.9 0-10.7 4.79-10.7 10.68 0 1.88.49 3.72 1.42 5.34L5.34 27l5.83-1.53c1.56.85 3.32 1.3 5.11 1.3h.01c5.9 0 10.7-4.79 10.7-10.68 0-2.85-1.11-5.53-3.13-7.55a10.66 10.66 0 0 0-7.55-3.11zm0 19.44c-1.6 0-3.16-.43-4.53-1.24l-.32-.19-3.36.88.9-3.27-.21-.34a8.9 8.9 0 0 1-1.36-4.6c0-4.9 4-8.89 8.9-8.89 2.38 0 4.61.93 6.29 2.6a8.85 8.85 0 0 1 2.6 6.29c0 4.9-3.99 8.89-8.89 8.89z" />
    </svg>
  );
}
